export default __webpack_public_path__ + "/assets/bg-infortuni-04.jpg";